import { ReactNode } from 'react'
import { Outlet, useLocation } from 'react-router-dom'
import { useAuthStore, useLogout } from '@features/auth'
import { RiskAgreementModal } from '@widgets/risk-agreement-modal'

const GUEST_PATHS = ['/login', '/signup', '/forgot-password']

interface PendingRiskAgreementProviderProps {
  children?: ReactNode
}

export const PendingRiskAgreementProvider = ({ children }: PendingRiskAgreementProviderProps) => {
  const { pathname } = useLocation()
  const isLoggedIn = useAuthStore(s => s.isLoggedIn)
  const pendingAgreementTypes = useAuthStore(s => s.pendingAgreementTypes)
  const clearPendingAgreementTypes = useAuthStore(s => s.clearPendingAgreementTypes)
  const { logout } = useLogout()

  const isGuestPath = GUEST_PATHS.includes(pathname)
  const isOpen = isLoggedIn && pendingAgreementTypes.length > 0 && !isGuestPath

  const handleAgreed = () => {
    clearPendingAgreementTypes()
  }

  const handleCancel = () => {
    clearPendingAgreementTypes()
    logout()
  }

  return (
    <>
      {children ?? <Outlet />}
      <RiskAgreementModal
        isOpen={isOpen}
        needAgree={pendingAgreementTypes}
        onAgreed={handleAgreed}
        onCancel={handleCancel}
      />
    </>
  )
}
